import http from "@/utils/request";

const UserRoleApi = {
  userBindRole(data) {
    return http.sendRequest({
      METHOD_NAME: "userRole.userBindRole",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
  userRoleList(data) {
    return http.sendRequest({
      METHOD_NAME: "userRole.userRoleList",
      SECURITY_TYPE: http.SecurityType.UserLogin.name,
      data,
      ERROR_CODE: {},
    });
  },
};
export default UserRoleApi;
